import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Thankyou = () => {
return(
<div className="page-content thank_error">
    <section className="wi_full py_3 error_thank_sec" >
        <div className="container">
            <div className="row align-items-center flex-lg-row-reverse">
                <div className="col-lg-6 img_col">
                    <img src="./images/thankyou.svg" alt="Thankyou" />
                </div>
                <div className="col-lg-6 text_col">
                    <h1><span>Thank you very</span> much for your message!</h1>
                    <p>We will be in touch as soon as possible.</p>
                    <div className="btn_block">
                        <Link to="/" className="button fill_btn">Back to Home</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
)
}